import React from 'react';
import CmlDiagnosisTable from './CmlDiagnosisTable';
import EltsCalculator from './EltsCalculator';
import TreatmentResponse from './TreatmentResponse';

interface CmlViewProps {
  activeTab: string;
}

const CmlView: React.FC<CmlViewProps> = ({ activeTab }) => {
  switch (activeTab) {
    case 'diagnosis':
      return <CmlDiagnosisTable />;
    case 'elts':
      return <EltsCalculator />;
    case 'response':
      return <TreatmentResponse />;
    default:
      return null;
  }
};

export default CmlView;
